
// additional suing translations, keeping separate from translations-*.ts in case those are updated in sui
export const TRANSLATIONS_SUING_FR = {
  report: {
    downloadExcelWorkbook: 'Télécharger en Excel Workbook (.xlsx)'
  }
}
